export default __webpack_public_path__ + "static/media/AGC_2022_R2_QP_Class_1.60ed78c0.pdf";